<dynamic-view-v2
  *ngIf="!isLoading"
  entityType="rewards-track"
  [viewName]="title"
  [record]="rewardsTrackRecord"
  [fields]="fields"
  [isFullWidth]="true"
  [isFullWidthButtons]="true"
>
</dynamic-view-v2>
